export interface IdentifiedSupportTicket {
  id: string;
}

/**
 * Cursor pages can overlap when a ticket changes while the operator is paging.
 * Keep the existing row (and its visual order) rather than rendering the same
 * ticket twice.
 */
export function appendUniqueSupportTickets<T extends IdentifiedSupportTicket>(
  current: readonly T[],
  incoming: readonly T[],
): T[] {
  const seen = new Set(current.map((ticket) => ticket.id));
  const uniqueIncoming: T[] = [];
  for (const ticket of incoming) {
    if (!seen.has(ticket.id)) {
      seen.add(ticket.id);
      uniqueIncoming.push(ticket);
    }
  }
  return [...current, ...uniqueIncoming];
}
